import * as React from 'react';
import {useState, useEffect} from "react";
import AddIcon from '@mui/icons-material/Add';
import {DataGrid, GridToolbarExport} from '@mui/x-data-grid';
import { Grid, TextField, FormControl, InputLabel, Select, MenuItem, Button, Box } from '@mui/material';
import {useNavigate} from 'react-router-dom'
import axios from "axios";
import {logout, getLocalToken} from '../../utils';
import { useParams } from "react-router-dom";
import PlanSteps from '../createNew';

export default function UserPlanReactivation() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState(true);
    const [familyMembers, setFamilyMembers] = useState([]);
    const {id} = useParams();

    const token = getLocalToken();

    useEffect(() => {
        axios.get(`/admin/api/v1/users/${id}`, {headers: {"Authorization": `Bearer ${token}`}})
            .then((res) => {
                if (res.status === 200) {
                    if (res.data.payload) {
                        setUser(res.data.payload);
                        setLoading(false);
                    }
                }
                fetchUserFamily()
            })
            .catch((err) => {
                setLoading(false);
                console.log(err);
                if (err.response.status === 401) {
                    logout();
                    navigate('/login');
                }
            });
    }, []);

    const fetchUserFamily = (userUID) => {
        axios.get(`/admin/api/v1/users/${id}/family`, {headers: {"Authorization": `Bearer ${token}`}})
            .then((res) => {
                if (res.status === 200 && res.data.payload) {
                    setFamilyMembers(res.data.payload);
                } else {
                    setFamilyMembers([]);
                }
            })
            .catch((err) => {

            })
            .finally(() => {

            });
    };

    return (
        <React.Fragment>
            <PlanSteps
                prefilledUser={user}
                prefilledFamily={familyMembers}
            />
        </React.Fragment>
    );
}